// Copyright (c) 2020 Deere & Company
import 'font-awesome/css/font-awesome.min.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import React, { Component } from 'react';
import { SecureRoute, Security } from '@okta/okta-react';
import ATPSetupPage from './admin/atp-setup';
import AppFooter from './common/components/app-footer';
import AppHeader from './common/components/app-header';
import AuditLogPage from './admin/auditlog';
import BatchAdminPage from './admin/batch-admin';

import FamilyAvailabilityPage from './parameters/family-availability';
import HomePage from './home-page';
import IntlProvider from '../intl-provider';
import { LoginCallback } from '../login-callback';
import OktaState from '../okta-state/state-connector';
import { Provider } from 'react-redux';
import RepingPage from './admin/reping';
import SelectUnitsPage from './select-units';
import UnitRoutes from './unit-routes';
import { WarrantyAlertBar } from './shared/components/warranty-alert-bar';
import { getOktaCredentials } from '../okta-env';
import store from '../store';

function DefaultPath () {

    return (
        <div>
            <h2>Default</h2>
            {' '}
            <p>Default Route to be shown when no matching path is detected</p>
        </div>
    );

}

// eslint-disable-next-line react/prefer-stateless-function
class ATPAppRoutes extends Component {

    render = () => {

        const {
            clientId, issuer
        } = getOktaCredentials();
        const scope = ['profile', 'openid', 'authorities'];
        return (
            <Provider store={store}>
                <IntlProvider>
                    <BrowserRouter>
                        { clientId && (
                            <Security
                                client_id={clientId}
                                issuer={issuer}
                                redirect_uri={`${window.location.origin}/callback`}
                                scope={scope}
                                pkce={true}
                            >
                                <OktaState />
                                <section className="app-container">
                                    <WarrantyAlertBar>
                                        <section className="app-container-without-footer">
                                            <AppHeader />
                                            <section className="app-content">
                                                <Switch>
                                                    <SecureRoute exact path="/" component={HomePage} />
                                                    <Route path="/callback" component={LoginCallback} />
                                                    <SecureRoute path="/atp-setup" component={ATPSetupPage} />
                                                    <SecureRoute path="/reping" component={RepingPage} />
                                                    <SecureRoute exact path="/batch-admin/reset-sna" component={FamilyAvailabilityPage} />
                                                    <SecureRoute path="/batch-admin" component={BatchAdminPage} />
                                                    <SecureRoute path="/auditlog" component={AuditLogPage} />
                                                    <SecureRoute path="/units" component={SelectUnitsPage} />
                                                    <SecureRoute path="/:unitCode" component={UnitRoutes} />
                                                    <Route component={DefaultPath} />
                                                </Switch>
                                            </section>
                                            <AppFooter />
                                        </section>
                                    </WarrantyAlertBar>
                                </section>
                            </Security>
                        )}
                    </BrowserRouter>
                </IntlProvider>
            </Provider>
        );

    };

}

export default ATPAppRoutes;
